import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const Gipserarbeiten = () => {
  const pageData = {
    title: 'GIPSERARBEITEN',
    subtitle: 'Perfekte Oberflächen',
    description: 'Professionelle Gipserarbeiten für glatte und ebene Wände und Decken. Präzision und Qualität für Ihr Bauprojekt.',
    heroImage: 'https://images.unsplash.com/photo-1768839725085-829e6ac7ac26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHx3b3JrZXIlMjBwbGFzdGVyaW5nJTIwd2FsbCUyMHRyb3dlbCUyMGNvbnN0cnVjdGlvbnxlbnwwfHx8fDE3Nzc2Mjk5NTF8MA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Innenputz', description: 'Hochwertige Innenputzarbeiten für perfekte Wände.' },
      { title: 'Außenputz', description: 'Wetterfeste Außenputze mit Langzeitschutz.' },
      { title: 'Gipskartonarbeiten', description: 'Montage und Verspachtelung von Gipskartonplatten.' },
      { title: 'Reparaturen', description: 'Ausbessern von Rissen und Beschädigungen.' },
      { title: 'Altbau-Sanierung', description: 'Spezialisten für historische Gebäude.' },
      { title: 'Glättarbeiten', description: 'Perfekt geglättete Oberflächen für Anstrich.' }
    ],
    benefits: [
      'Jahrelange Erfahrung im Gipserhandwerk',
      'Saubere und präzise Ausführung',
      'Hochwertige Materialien',
      'Termintreue Fertigstellung',
      'Faire Preisgestaltung',
      'Fachgerechte Altbausanierung'
    ],
    process: [
      { title: 'Begutachtung', description: 'Analyse des Untergrunds und Schadensbewertung.' },
      { title: 'Vorbereitung', description: 'Reinigung und Grundierung der Flächen.' },
      { title: 'Verputzen', description: 'Auftragen des Putzes in mehreren Schichten.' },
      { title: 'Glätten', description: 'Finale Glättung für perfekte Oberfläche.' }
    ],
    metaKeywords: 'Gipser Cazis, Gipserarbeiten Graubünden, Innenputz, Außenputz, Verputzen'
  };

  return <ServiceTemplate {...pageData} />;
};

export default Gipserarbeiten;